import { colors } from "../../Styles";

export function Stop({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <path d="M141.73,9.29C68.71,9.29 9.29,68.71 9.29,141.73C9.29,214.75 68.7,274.17 141.73,274.17C214.76,274.17 274.17,214.76 274.17,141.73C274.17,68.7 214.76,9.29 141.73,9.29ZM141.73,248.18C83.03,248.18 35.28,200.43 35.28,141.73C35.28,83.03 83.03,35.28 141.73,35.28C200.43,35.28 248.18,83.03 248.18,141.73C248.18,200.43 200.43,248.18 141.73,248.18Z"/>
      <g transform="matrix(1.1813,0,0,1.1813,-25.69,-25.7018)">
          <path d="M189.22,108.157L189.22,175.303C189.22,182.984 182.984,189.22 175.303,189.22L108.157,189.22C100.476,189.22 94.24,182.984 94.24,175.303L94.24,108.157C94.24,100.476 100.476,94.24 108.157,94.24L175.303,94.24C182.984,94.24 189.22,100.476 189.22,108.157Z"/>
      </g>
  </svg>
  );
}
